import { render } from "./LoadedPositionsDialog.vue?vue&type=template&id=1b4fe90a&scoped=true"
import script from "./LoadedPositionsDialog.vue?vue&type=script&lang=js"
export * from "./LoadedPositionsDialog.vue?vue&type=script&lang=js"

import "./LoadedPositionsDialog.vue?vue&type=style&index=0&id=1b4fe90a&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b4fe90a"]])

export default __exports__